"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplyTargetContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _commentReply = require("../../../utils/comment-reply");
var _document = require("../../../utils/document");
var _CommentAnchorContext = require("./CommentAnchorContext");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var UNAVAILABLE_COMMENT_PHRASE = "a comment that is no longer in the document";
var readCommentContent = function readCommentContent(commentId) {
  return (0, _document.withWordContextRead)(function (context) {
    return (0, _commentReply.commentContentOf)(context, commentId);
  });
};
var ReplyTargetContext = exports.ReplyTargetContext = function ReplyTargetContext(_ref) {
  var targetCommentId = _ref.targetCommentId,
    targetCommentText = _ref.targetCommentText;
  var reading = (0, _CommentAnchorContext.useContextTextReading)(targetCommentText, targetCommentId, readCommentContent);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentAnchorContext.ProposalCardContextLine, {
    lead: "Replying to",
    reading: reading,
    unavailablePhrase: UNAVAILABLE_COMMENT_PHRASE,
    "data-sentry-element": "ProposalCardContextLine",
    "data-sentry-component": "ReplyTargetContext",
    "data-sentry-source-file": "ReplyTargetContext.tsx"
  });
};